import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderDetailsConfirmationNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    status?: TypographyProps;
}

export const ConfirmationNumberStyles: OrderDetailsConfirmationNumberStyles = {
    wrapper: {
        css: css`
            padding-bottom: 0.625rem;
            font-size: ${themeFontSizes.size18};
            letter-spacing: 0;
            line-height: 1.4375rem;
            font-family: 'Lato',sans-serif;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: ${themeFontSizes.size18};
            }
            margin-bottom: 0.3125rem;
            margin-right: 0.3125rem;
            color: ${themeColors.colorPrimary};
            font-size: ${themeFontSizes.size18};
            font-family: 'Roboto', sans-serif;
            font-weight: ${themeFontWeights.fontWeightForBold};
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    status: {
        css:css`
                margin-top: 3px;
                margin-bottom: 0.3125rem;
                margin-right: 0.3125rem;
                font-size: ${themeFontSizes.size18};
                display: inline-block;
                color: ${themeColors.colorCharcoalGrey};
                font-family: 'Roboto', sans-serif;
                line-height: 27px;
        `,
    },
};
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;
const styles = ConfirmationNumberStyles;

const OrderDetailsConfirmationNumber : FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);
    if ((!order || !order.webOrderNumber)&&(!orderData || !orderData.webOrderNumber)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsConfirmationNo">
            {translate("Confirmation #")}
            </Typography>
            <Typography {...styles.status} aria-labelledby="orderDetailsConfirmationNo">
                 {order?.webOrderNumber||orderData?.webOrderNumber} 
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDetailsConfirmationNumber),
    definition: {
        allowedContexts: [OrderDetailsPageContext,"OrderStatusPage"],
        group: "Order Details",
    },
};

export default widgetModule;